import https from '../init/https';

//USER-INFO-01 : User account information
export async function userInfoFun() {
    const userData = await https.get(`/user`);
    return userData;
}

//USER-INFO-02 : List of user booking
export async function userBookingFun(type, limit, offSet) {
    const booking = await https.get(`/user/booking/${type}?limit=${limit}&offset=${offSet}`);
    return booking;
}

//USER-INFO-03 : List of user wishlist
export async function userWishlistFun(type, limit, offSet) {
    const wishlist = await https.get(`/user/wishlist/${type}?limit=${limit}&offset=${offSet}`);
    return wishlist;
}

//USER-INFO-04 : add rating to a trip which user has been to
export async function userReview(type, data) {
    const review = await https.post(`/user/rate/${type}`, data);
    return review;
}

//USER-INFO-05 : add a paticalar package to wishlist of user
export async function addWishlistFun(type, data) {
    const wishlist = await https.post(`user/wishlist/${type}`, data);
    return wishlist;
}

//USER-INFO-06 : cancel a booking
export async function cancelFun(type, bookingId) {
    const cancelData = await https.post(`/user/cancel/${type}/${bookingId}`);
    return cancelData;
}

//USER-INFO-07 : To edit the information of the customer by info sent in body
export async function userEditFun(data) {
    const edit = await https.patch(`/user`, data);
    return edit;
}

//USER-INFO-08 : User can edit the rating of a particular review
export async function editRatingFun(type, reviewId, data) {
    const edit = await https.patch(`/user/rate/${type}/${reviewId}`, data);
    return edit;
}

//USER-INFO-09 : To delete a praticular item from the wishlist
export async function delWishFun(type, packId) {
    const edit = await https.delete(`/user/wishlist/${type}/${packId}`);
    return edit;
}

//USER-INFO-10 : Delete a particular review.
export async function deleteReviewFun(type, reviewId) {
    const edit = await https.delete(`/rate/${type}/${reviewId}`);
    return edit;
}

//USER-INFO-11 : Contact us.
export async function contactUs(data) {
    const contactData = await https.post(`/user/contact-us/email`, data);
    return contactData;
}

//USER-INFO-12 : Check user has been to trip.
export async function CheckTrip(type, packId) {
    const checkTrip = await https.get(`/user/check/${type}/${packId}`);
    return checkTrip;
}

//USER-INFO-13 : List of user wishlist
export async function userWishlistIdFun(type) {
    const wishlist = await https.get(`/user/wishlist/id/${type}`);
    return wishlist;
}

//USER-INFO-14 : add rating to a trip which user has been to from email / sms
export async function userUnAuthReview(type, data) {
    const review = await https.post(`/user/id/rate/${type}`, data);
    return review;
}

//USER-INFO-15 : get refund amount for cancellation of booking
export async function refundAmount(data) {
    const amount = await https.post(`/user/refund/amount`, data);
    return amount;
}

//USER-INFO-16 : User whishlist count
export async function userWishlistCount(type) {
    const count = await https.get(`/user/count/wishlist?type=${type}`);
    return count;
}

//USER-INFO-17 : User Booking count
//USER-INFO-21 : v2 My Bookings — one page of bookings + total (amounts as saved)
// type: trip | camp | act | gu   status: next | prev | all
export async function userBookingsV2Fun(type, { status = 'all', limit = 10, offset = 0 } = {}) {
    const result = await https.get(`/user/v2/bookings/${type}`, { params: { status, limit, offset } });
    return result;
}

export async function userBookingCount(type) {
    const count = await https.get(`/user/count/booking?type=${type}`);
    return count;
}

//USER-INFO-18 : User Review count
export async function userReviewCount(type) {
    const count = await https.get(`/user/count/review?type=${type}`);
    return count;
}

//USER-INFO-19 : List of user reviews
export async function userReviewFun(type) {
    const booking = await https.get(`/user/review/list?type=${type}`);
    return booking;
}

// USER-INFO-20: Update booking date and pickup location
export async function updateUserBookingDateAndPickupLocation(type, date, pickup, data) {
    const updateBooking = await https.patch(`/user/booking/edit/${type}`, data, {
        params: { date, pickup }
    });
    return updateBooking;
}

//USER-INFO-21 - Use coins or cash back
export async function claimCashOrCoins(data) {
    const result = await https.post(`/user/claim/back`, data);
    return result;
}
